import Analytics from '@shared/services/Analytics';
import router from '@app/config/router';

Analytics.load('G-69D1ZDBCCG', { router });
